export default __webpack_public_path__ + "static/media/080_finish_good.a25fa91d.mp4";